import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiService } from '@core/providers/http';
import { map, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CategoriaService {
  public params = new HttpParams();

  constructor(private readonly apiService: ApiService) { }

  // listar categorias
  list(params?: any): Observable<any> {
    return this.apiService.get(`/api/Categorias`, params ? new HttpParams({
      fromObject: params
    }) : this.params,
    ).pipe(
      map(response => response)
    );
  }

  //listar por id
  show(id: string): Observable<any> {
    return this.apiService.get(
      `/api/Categoria/${id}`,
    ).pipe(
      map(response => response)
    );
  }

  /**
* Cria uma nova categoria
* @param categoria
* @returns Observable<any>
*/
  public store(categoria: any): Observable<any> {
    return this.apiService.post(`/api/Categorias`, categoria);
  }

  // atualizar categoria
  update(categoria: any, id: string): Observable<any> {
    return this.apiService.put(`/api/Categorias/${id}`, categoria);
  }

  delete(id: string): Observable<any> {
    return this.apiService.delete(`/api/Categorias/${id}`);
  }
}